import { injectable } from 'inversify';
import {
  army_list_unit_unit_option,
  army_list_unit_unit_option_dto,
} from '@Api';
import { ArmyListUnitOption } from '@Models';

@injectable()
export class ArmyListUnitUnitOptionMapper {
  public map(item: army_list_unit_unit_option): ArmyListUnitOption {
    return {
      id: item.id,
      unit_option_id: item.unit_option_id,
      name: item.name,
      quantity: item.quantity,
      points: item.value_points,
      isDeleted: false,
    } satisfies ArmyListUnitOption as ArmyListUnitOption;
  }

  public mapDto(item: ArmyListUnitOption): army_list_unit_unit_option_dto {
    return {
      id: item.id != '' ? item.id : null,
      unit_option_id: item.unit_option_id,
      quantity: item.quantity,
      value_points: item.points,
      _destroy: item.isDeleted,
    } satisfies army_list_unit_unit_option_dto as army_list_unit_unit_option_dto;
  }
}
